export default __webpack_public_path__ + "static/media/1-4@2x.251b0017.png";